import _ from 'lodash';

export function getIntegerFromStyle(style: string): number {
  return _.round((parseFloat(style) || 0));
}
